import { call, put, takeLatest } from "redux-saga/effects";
import Swal from "sweetalert2";
import * as types from "./actionTypes";
import { post, get } from "../../../helpers/api_helper";

function* saveCircularSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_SAVE_CIRCULAR, action.payload);

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to create circular!");
    }

    // SweetAlert success
    Swal.fire({
      title: "Success",
      text: response?.message || "Circular saved successfully!",
      icon: "success",
      confirmButtonText: "OK",
    });

    yield put({ type: types.CREATE_CIRCULAR_SUCCESS, payload: response });
  } catch (error) {
    // SweetAlert failure
    Swal.fire({
      title: "Error",
      text: error.message || "Something went wrong while saving circular!",
      icon: "error",
      confirmButtonText: "OK",
    });

    yield put({ type: types.CREATE_CIRCULAR_FAILURE, payload: error });
  }
}

export default function* circularSaga() {
  yield takeLatest(types.CREATE_CIRCULAR_REQUEST, saveCircularSaga);
}
